export default __webpack_public_path__ + "static/media/sa.f13ef5af.jpg";